import {AxiosResponse} from 'axios';
import EfeApi from 'services/api/Api';
import {EfeResponse} from 'commons/models';
import {
    ValidateIneReq,
    ValidateIneResponse,
    ValidationsCURPRequest,
    ValidationsCURPResponse,
    ValidationsINERequest,
    ValidationsINEResponse,
} from 'commons/models/dtos/validations/Validations';

async function validateDni(
    request: ValidationsINERequest
): Promise<EfeResponse<ValidationsINEResponse>> {
    try {
        return await EfeApi.Validations.post<ValidationsINEResponse>(
            '/v1/aml/utils/datos/ocr ',
            request
        ).then((res: AxiosResponse<ValidationsINEResponse>) => {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function validateCurp(
    request: ValidationsCURPRequest
): Promise<EfeResponse<ValidationsCURPResponse>> {
    try {
        return await EfeApi.Validations.post<ValidationsCURPResponse>(
            '/v1/aml/utils/verificaciones/curp',
            request
        ).then((res: AxiosResponse<ValidationsCURPResponse>) => {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}
async function evaluateIneData(request: ValidateIneReq): Promise<EfeResponse<ValidateIneResponse>> {
    try {
        return await EfeApi.Validations.post<ValidateIneResponse>(
            '/v1/aml/utils/verificaciones/ine',
            request
        ).then((res: AxiosResponse<ValidateIneResponse>) => {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

export default {
    validateDni,
    validateCurp,
    evaluateIneData
};
